import { render, staticRenderFns } from "./TemplateGroup.vue?vue&type=template&id=6de75b5e&scoped=true"
import script from "./TemplateGroup.vue?vue&type=script&lang=js"
export * from "./TemplateGroup.vue?vue&type=script&lang=js"
import style0 from "./TemplateGroup.vue?vue&type=style&index=0&id=6de75b5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de75b5e",
  null
  
)

export default component.exports